export default function isScriptLoaded (src) {
  return document.querySelector('script[src="' + src + '"]') ? true : false
}
